import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <Svg width="16" height="17" viewBox="0 0 16 17" fill="none" {...props}>
      <path
        d="M2.15779 11.5454C2.15255 11.5402 2.14742 11.5349 2.14239 11.5294C2.09885 11.4826 2.06529 11.4298 2.04172 11.3738C2.01485 11.3101 2 11.2401 2 11.1667L2 11.1651C2.00041 11.0291 2.05248 10.8933 2.15621 10.7895L4.28954 8.6562C4.49782 8.44792 4.83551 8.44792 5.04379 8.6562C5.25206 8.86448 5.25206 9.20217 5.04379 9.41044L3.8209 10.6333H10.5333C10.8279 10.6333 11.0667 10.8721 11.0667 11.1667C11.0667 11.4612 10.8279 11.7 10.5333 11.7H3.82092L5.04379 12.9229C5.25206 13.1311 5.25206 13.4688 5.04379 13.6771C4.83551 13.8854 4.49782 13.8854 4.28954 13.6771L2.15779 11.5454Z"
        fill={props.color}
        fillOpacity="0.6"
      />
      <path
        d="M4.13354 5.83331C4.13354 5.53876 4.37232 5.29998 4.66687 5.29998H11.9127L10.6898 4.0771C10.4815 3.86882 10.4815 3.53114 10.6898 3.32286C10.8981 3.11458 11.2358 3.11458 11.444 3.32286L13.5774 5.45619C13.7856 5.66446 13.7856 6.00215 13.5774 6.21043L11.444 8.34376C11.2358 8.55204 10.8981 8.55204 10.6898 8.34376C10.4815 8.13548 10.4815 7.79779 10.6898 7.58951L11.9127 6.36665L4.66687 6.36665C4.37232 6.36665 4.13354 6.12787 4.13354 5.83331Z"
        fill={props.color}
        fillOpacity="0.6"
      />
    </Svg>
  );
};

export default Icon;
